// Display metadata for each draft-change type, shared by the draft-changes
// list and the publish-review modal so labels / colours stay consistent.
export const CHANGE_TYPE_META = {
    cover:         { chip: 'Cover',          group: 'Cover shifts',        cls: 'bg-blue-100 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400',     dot: 'bg-blue-500' },
    reassign:      { chip: 'Team move',      group: 'Team moves',          cls: 'bg-indigo-100 dark:bg-indigo-900/10 text-indigo-700 dark:text-indigo-400', dot: 'bg-indigo-500' },
    rename:        { chip: 'Team edit',      group: 'Team edits',          cls: 'bg-violet-100 dark:bg-violet-900/10 text-violet-700 dark:text-violet-400', dot: 'bg-violet-500' },
    removeDay:     { chip: 'Remove day',     group: 'Removed roster days',  cls: 'bg-rose-100 dark:bg-rose-900/10 text-rose-700 dark:text-rose-400',    dot: 'bg-rose-500' },
    review:        { chip: 'Hours',          group: 'Recorded hours',      cls: 'bg-emerald-100 dark:bg-emerald-900/10 text-emerald-700 dark:text-emerald-400', dot: 'bg-emerald-500' },
    absence:       { chip: 'Absence',        group: 'Holidays / leave',    cls: 'bg-sky-100 dark:bg-sky-900/10 text-sky-700 dark:text-sky-400',       dot: 'bg-sky-500' },
    removeAbsence: { chip: 'Remove holiday', group: 'Removed holidays',    cls: 'bg-amber-100 dark:bg-amber-900/10 text-amber-700 dark:text-amber-400',   dot: 'bg-amber-500' },
};

export const changeTypeMeta = (type) =>
    CHANGE_TYPE_META[type] || { chip: type, group: type, cls: 'bg-slate-100 dark:bg-slate-900/10 text-slate-700 dark:text-slate-400', dot: 'bg-slate-500' };

// Group a flat change queue by type, preserving first-seen order, each with its
// display metadata — used by the publish-review modal's grouped summary.
export const groupChangesByType = (changes) => {
    const order = [];
    const map = {};
    for (const c of changes) {
        if (!map[c.type]) { map[c.type] = []; order.push(c.type); }
        map[c.type].push(c);
    }
    return order.map((type) => ({ type, items: map[type], meta: changeTypeMeta(type) }));
};
